import { useState, useCallback } from 'react';

export const useWeekendCheck = () => {
  const [showWeekendWarning, setShowWeekendWarning] = useState(false);
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);

  // فحص إذا كان اليوم جمعة أو سبت
  const isWeekend = useCallback((dateString: string): boolean => {
    const date = new Date(dateString);
    const dayOfWeek = date.getDay();
    // 5 = جمعة، 6 = سبت
    return dayOfWeek === 5 || dayOfWeek === 6;
  }, []);

  // فحص والتعامل مع أيام الإجازة
  const checkWeekendAndProceed = useCallback((
    dateString: string, 
    action: () => void
  ) => {
    if (isWeekend(dateString)) {
      // إذا كان يوم إجازة، اعرض التحذير
      setPendingAction(() => action);
      setShowWeekendWarning(true);
    } else {
      // إذا لم يكن يوم إجازة، نفذ الإجراء مباشرة
      action();
    }
  }, [isWeekend]);

  // تأكيد المتابعة رغم يوم الإجازة
  const handleWeekendConfirm = useCallback(() => {
    if (pendingAction) {
      pendingAction();
      setPendingAction(null);
    }
    setShowWeekendWarning(false);
  }, [pendingAction]);

  // إلغاء الإجراء
  const handleWeekendCancel = useCallback(() => {
    setPendingAction(null);
    setShowWeekendWarning(false);
  }, []);

  return {
    isWeekend,
    showWeekendWarning,
    checkWeekendAndProceed,
    handleWeekendConfirm,
    handleWeekendCancel,
    setShowWeekendWarning
  };
};